import { Button, Card, CardContent } from "@mui/material";
import Grid from '@mui/material/Grid2';
import postProcessing from "./postProcessing";
import DeleteIcon from "@mui/icons-material/Delete";
import VerifiedIcon from "@mui/icons-material/Verified";

function SingleUser({ userData, managerMode, devPort, listMode, refresher }) {
  function moveOffWaitlist(
    userId,
    playerFirstName,
    playerLastName,
    registerClubId
  ) {
    fetch(devPort + "edit_player", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        player_id: userId,
        first_name: playerFirstName,
        last_name: playerLastName,
        uspa_rating: -2,
        club_rating: -2,
        club_id: registerClubId,
        is_club_pro: false,
        waitlist: "0",
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("OFF WAITLIST");
        refresher();
      });
  }

  return (
    <Card>
      <CardContent>
        <Grid container size={{xs:12}}>
          <Grid size={{xs:6}}>{userData.label}</Grid>
          {managerMode === -1 && listMode === "waitlist" && (
            <Grid size={{xs:3}}>
              <Button
                variant="contained"
                color="success"
                onClick={() => {
                  console.log("Accept");
                  moveOffWaitlist(
                    userData.value,
                    userData.firstName,
                    userData.lastName,
                    userData.clubId
                  );
                }}
              >
                <VerifiedIcon />{" "}
              </Button>
            </Grid>
          )}
          {managerMode === -1 && (
            <Grid size={{xs:3}}>
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  console.log("DELETE");
                  const fetch_delete =
                    listMode === "stripe_connect_access"
                      ? devPort + "edit_player_connect"
                      : "";
                  const fetch_json =
                    listMode === "stripe_connect_access"
                      ? {
                          club_id: userData.clubId,
                          player_id: userData.value,
                          allowed_stripe_connect: 0,
                        }
                      : {};
                  postProcessing(fetch_delete, fetch_json, () => {
                    console.log("Request has been rejected");
                    refresher();
                  });
                }}
              >
                <DeleteIcon />{" "}
              </Button>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}

export default SingleUser;
